import {PedidoAdicional} from './PedidoAdicional'

export class AdicionalPedidoAberto {
    pedidoItemId: number = 0
    adicionais: PedidoAdicional[] = []
    clienteId?: string | null
}